<template>
	<div class="qr-container">
		<div class="text-center">
			<h1 class="qr-status">QR CODE 종료</h1>
			<h2 class="qr-message">종료된 QR CODE입니다.</h2>
			<h2 class="qr-message">현장에서 새롭게 발급된</h2>
			<h2 class="qr-message">QR CODE를 활용해주세요.</h2>
		</div>
	</div>
</template>

<style lang="scss" scoped>
.qr-container {
	align-items: center;
	background: #fff;
	display: flex;
	justify-content: center;
	min-height: 100vh;
	width: 100%;
}

.qr-status {
	font-size: 2rem;
	font-weight: 400;
	line-height: 1;
	margin: 0;
}

.qr-message {
	font-size: 1.5rem;
	font-weight: 300;
	line-height: 1;
	margin: 0;
}
</style>

<script>
export default {
	name: 'not-exist-QRCODE',
	metaInfo: {
		title: 'QR코드 종료',
	},
}
</script>
